import { render, staticRenderFns } from "./CayGiaPha.vue?vue&type=template&id=2b320012&"
import script from "./CayGiaPha.vue?vue&type=script&lang=js&"
export * from "./CayGiaPha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports